import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=5cbf9bae&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"
import style0 from "./LoginView.vue?vue&type=style&index=0&id=5cbf9bae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbf9bae",
  null
  
)

export default component.exports